<!-- 设备管理的页面-->
<template>
  <div class="device-index-page">
    <el-container class="device-whole">
      <el-aside class="device-left">
        <el-header class="myfixing" style="height: 50px">我的设备</el-header>
        <el-main class="search">
          <el-input placeholder="请输入关键词"
                    :class="'searchInput'"
                    v-model="searchVal"
                    @input="setSearchVal(searchVal)">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <ul class="devicelist">
            <li v-for="(items, index) in filteredDeviceList" @click="clickDevice(index)" :key="index"
                :class="{actived:index===getDeviceIndex}">
              <!-- 根据type来确定样式  -->
              <i class="el-input__icon el-icon-printer" v-if="items.type === 'ecan'"></i>
              <i class="el-input__icon el-icon-star-off" v-else></i>
              <tr class="name">{{items.name}}</tr>
              <i class="el-input__icon el-icon-edit" @click.stop="clickDeviceRename(index)"></i>
<!--              <i class="el-input__icon"-->
<!--                 :class="{'el-icon-open':items.status===DEVICE_STATUS.RUNNING,-->
<!--                 'el-icon-turn-off':items.status===DEVICE_STATUS.FREE,}">-->
<!--              </i>-->
              <i class="el-input__icon el-icon-open" v-if="items.online===true" style="color: rgb(26, 122, 230)"></i>
              <i class="el-input__icon el-icon-turn-off" v-else></i>
              <i class="el-input__icon">
                {{getNetStatusText(items.networkStatus)}}
              </i>
            </li>
          </ul>
        </el-main>
        <el-dialog :title="`设备重命名(${deviceRenameForm.preName})`" :visible.sync="deviceRenameDialog"
                   width="360px">
          <el-form :model="deviceRenameForm" :rules="deviceRenameRules" ref="deviceRenameForm">
            <el-form-item label="设备名称" prop="name">
              <el-input v-model="deviceRenameForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="deviceRenameDialog = false">取 消</el-button>
            <el-button type="primary" @click="toRenameDevice('deviceRenameForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-aside>
      <el-main class="device-right">
        <v-right-part></v-right-part>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import DeviceParameter from '@/components/device/deviceParameter';
import {mapGetters, mapActions, mapMutations,} from 'vuex';
import { DEVICE_STATUS, DEVICE_NET_STATUS } from '@/common/enums';

export default {
  name: 'device-index-page',
  data() {
    return {
      DEVICE_STATUS,
      DEVICE_NET_STATUS,
      searchVal: '',
      deviceRenameDialog: false,
      deviceRenameForm: {
        name: '',
        id: -1,
      },
      deviceRenameRules: {
        name: [{ required: true, message: '请输入需要设备的名称', trigger: 'blur' }],
      },
    };
  },
  components: {
    'v-right-part': DeviceParameter,
  },
  created() {
    const self = this;
    document.onkeydown = function () {
      const key = window.event.keyCode;
      if (key === 13) {
        // 按Enter键时保持页面序号为0
        self.$store.commit('setPageIndex', 0);
      }
    };
  },
  mounted() {
    const router = this.$store.getters.getRouterSnapshot;
    this.$store.commit('setRouterSnapshot', '/');
    this.$router.push(router);
    this.getDeviceList();
    // 加载时默认设置页面序号为0
    this.$store.commit('setPageIndex', 0);
    // 加载时默认根据上次搜索结果选择第一个
    this.searchVal = this.getSearchVal;
    this.clickDevice(this.getDeviceIndex);
  },
  computed: {
    ...mapGetters('Device', ['getByName', 'getDeviceIndex', 'getSearchVal']),
    /**
         * 被过滤后的设备列表
         */
    filteredDeviceList() {
      const list = this.getByName(this.getSearchVal);
      return list;
    },
    deviceListLength() {
      return this.filteredDeviceList.length;
    },
  },
  methods: {
    ...mapMutations('Device', ['setDeviceIndex', 'setCurDetailData', 'setDeviceFileList', 'setSearchVal', 'setCurConfig','setCurOnline']),
    ...mapActions('Device', ['getDeviceList', 'renameDevice', 'getDeviceDetail', 'getDeviceFileList', 'getDeviceConfig', 'getFileUploadStatus', 'getOTAStatus']),
    /**
       * 根据网络状态，得到text
       */
    getNetStatusText(status) {
      if (status === DEVICE_NET_STATUS.LOCAL_WIFI) {
        return 'WiFi';
      }
      if (status === DEVICE_NET_STATUS.HOTSPOT_WIFI) {
        return 'Hotspot';
      }
      if (status === DEVICE_NET_STATUS.FOURTH_G) {
        return '4G';
      }
      if (status === DEVICE_NET_STATUS.UNKNOWN) {
        return 'Unknown';
      }
      return 'Unknown';
    },
    /**
       * 用来重命名设备的name
       * @param index 要重命名的设备索引
       */
    clickDeviceRename(index) {
      this.deviceRenameDialog = true;
      this.deviceRenameForm.preName = this.filteredDeviceList[index].name;
      this.deviceRenameForm.index = this.filteredDeviceList[index].id;
      const self = this;
      document.onkeydown = function () {
        const key = window.event.keyCode;
        if (key === 13) {
          self.toRenameDevice('deviceRenameForm');
        }
      };
    },
    /**
       * 确定需要修改
       * @param formName 弹出的form的名字
       */
    toRenameDevice(formName) {
      const self = this;
      const newName = self.deviceRenameForm.name;
      const index = self.filteredDeviceList.findIndex(item => item.name === newName);
      if (index > -1) {
        this.$message({
          message: '名字已存在',
          type: 'error',
        });
        return;
      }
      self.renameDevice({
        id: self.deviceRenameForm.index,
        name: self.deviceRenameForm.name,
      }).then(() => {
        // 如果增加成功，dialog消失
        self.$refs[formName].resetFields();
        self.deviceRenameDialog = false;
        this.$message({
          showClose: true,
          message: '重命名成功',
          type: 'success',
        });
        this.getDeviceList();
      }).catch((err) => {
        const { errorMsg = '' } = err;
        this.$message({
          showClose: true,
          message: errorMsg || '重命名失败！',
          type: 'error',
        });
      });
    },
    /**
       * 点击对应的设备，切换详情
       * @param index 设备索引
       */
    clickDevice(index) {
      this.setDeviceIndex(index);
      if (this.filteredDeviceList.length === 0) {
        this.setCurDetailData({});
        this.setDeviceFileList([]);
        this.setCurConfig({});
      } else {
        if (this.filteredDeviceList[index].online){
          this.setCurOnline(true)
          this.getDeviceDetail({
            id: this.filteredDeviceList[index].id,
          });
          // 切换的时候根据设备id获取设备文件列表
          this.getDeviceFileList({
            id: this.filteredDeviceList[index].id,
          });
          this.getDeviceConfig({
            id: this.filteredDeviceList[index].id,
          });
          this.getFileUploadStatus({
            id: this.filteredDeviceList[index].id,
          });
          this.getOTAStatus({
            deviceId: this.filteredDeviceList[index].id,
          });
        } else {
          this.setCurOnline(false)
          this.$message({
            showClose: true,
            message: '该设备已下线！',
            type: 'warning'
          });
        }
      }
    },
  },
  /**
   *在使用搜索框时，应使设备序号定位到搜索结果的第一个并更换至相应设备信息，避免出现信息不对称
   */
  watch: {
    searchVal() {
      this.setSearchVal(this.searchVal);
    },
    // 当列表长度改变时，定位设备序号到当前过滤列表第一个
    deviceListLength() {
      this.clickDevice(0);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../style/mixin";
  @import '../../style/media';

  .device-index-page {
    height: 100%;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .device-whole {
      background: rgba(221, 221, 221, 0.17);
      width: 100%;
      height: 100%;
      @include max_800{
        width: 800px;
      };
      .device-left {
        border: 1px solid #eee;
        @include max_800 {
          width: 256px !important;
        }
        @include center_800_1280 {
          width: 32% !important;
        }
        @include min_1280 {
          width: 408px !important;
        }
        height: 100%;
        display: flex;
        flex-direction: column;


        .myfixing {
          width: 100%;
          height: 40px;
          flex-shrink: 0;
          flex-grow: 0;
          line-height: 50px;
          padding-left: 16px;
          margin-top: 5px;
          font-size: 16px;
          border-bottom: 1px solid #eee;
          font-weight:bold;
        }

        .search {
          height: 100%;
          width: 100%;
          padding: 20px 15px 0;
          display: flex;
          flex-direction: column;

          .searchInput {
            flex-shrink: 0;
            flex-grow: 0;
          }

          .devicelist {
            height: 100%;
            width: 100%;
            vertical-align: middle;
            @include focus-scroll-bar;
            li:hover {
              border: 2px rgba(41, 156, 206, 0.76) solid;
              background: #fff;
            }

            .actived {
              border: 2px rgba(51, 137, 232, 0.66) solid;
            }

            .name {
              @include max_800 {
                width: 100px;
              }
              @include center_800_1280 {
                width: 45%;
              }
              @include min_1280 {
                width: 45%;
              }
              word-wrap: break-word;
              word-break: break-all;
              overflow-x: hidden;
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-box-pack: center;
              -webkit-box-align: center;
              -webkit-box-orient: vertical;
              text-align: center;
            }

            li {
              height: 60px;
              margin-top: 20px;
              background: #fff;
              display: flex;
              border-radius: 6px;

              i {
                flex: 1;
                line-height: 60px;
              }

              i:nth-child(3) {
                cursor: pointer;
              }
            }
          }
        }
      }

      .device-right {
        margin-left: 1%;
        margin-right: 1%;
        margin-top:1%;
        height: 100%;
        @include focus-scroll-bar;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/device/index.vue